import { render, staticRenderFns } from "./AutoImplantacao.vue?vue&type=template&id=1c50ed4a&scoped=true&"
import script from "./AutoImplantacao.vue?vue&type=script&lang=js&"
export * from "./AutoImplantacao.vue?vue&type=script&lang=js&"
import style0 from "./AutoImplantacao.vue?vue&type=style&index=0&id=1c50ed4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50ed4a",
  null
  
)

export default component.exports